import React from 'react';
// import { motion } from 'framer-motion';
// import { Link } from 'react-router-dom';
// import SafeIcon from '../common/SafeIcon';
// import ExitIntentPopup from './ExitIntentPopup';
// import useExitIntent from '../hooks/useExitIntent';
// import * as FiIcons from 'react-icons/fi';

// const { FiCode, FiArrowRight, FiBook, FiUsers, FiClock } = FiIcons;

const CoursesPage = () => {
  return (
    <div className="min-h-screen bg-black-900 text-white flex flex-col items-center justify-center p-4">
      <h1 className="text-4xl font-bold mb-4 font-serif">Page Temporarily Disabled</h1>
      <p className="text-lg text-black-300">This page is currently unavailable.</p>
    </div>
  );
  /*
  const { showExitIntent, closeExitIntent } = useExitIntent();

  // Animation variants for consistent animations
  const fadeInUp = { hidden: { opacity: 0, y: 30 }, visible: { opacity: 1, y: 0 } };
  const staggerChildren = { hidden: { opacity: 0 }, visible: { opacity: 1, transition: { staggerChildren: 0.1 } } };

  return (
    <div className="min-h-screen bg-white pt-16">
      
      <ExitIntentPopup 
        isVisible={showExitIntent} 
        onClose={closeExitIntent} 
      />

      
      <section className="pt-20 pb-16 bg-gradient-to-br from-black-900 to-black-800 text-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial="hidden"
            animate="visible"
            variants={{ visible: { transition: { staggerChildren: 0.2 } } }}
            className="text-center"
          >
            <motion.h1
              variants={fadeInUp}
              className="text-4xl md:text-6xl font-bold mb-8 leading-tight font-serif"
            >
              Courses Archive
            </motion.h1>
            <motion.p
              variants={fadeInUp}
              className="text-xl text-black-200 mb-10 leading-relaxed max-w-3xl mx-auto"
            >
              Learn practical skills with hands-on courses designed for real-world application
            </motion.p>
          </motion.div>
        </div>
      </section>
      
      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-100px" }}
            variants={fadeInUp}
            className="text-center mb-12"
          >
            <h2 className="text-3xl md:text-5xl font-bold text-black-900 mb-6 font-serif">
              Available Courses
            </h2>
            <div className="w-24 h-1 bg-black-900 mx-auto mt-6 mb-6"></div>
            <p className="text-xl text-black-700 max-w-3xl mx-auto">
              Comprehensive courses to help you build practical skills
            </p>
          </motion.div>

          
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={staggerChildren}
            className="max-w-4xl mx-auto"
          >
            <motion.div
              variants={fadeInUp}
              className="bg-white rounded-xl shadow-lg overflow-hidden border border-black-200 hover:shadow-xl transition-all duration-300"
            >
              <div className="grid md:grid-cols-2 gap-0">
                
                <div className="bg-gradient-to-br from-blue-600 to-purple-700 p-8 flex items-center justify-center relative">
                  <div className="text-center">
                    <div className="w-24 h-24 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-6">
                      <SafeIcon icon={FiCode} className="w-12 h-12 text-white" />
                    </div>
                    <h3 className="text-3xl font-bold text-white mb-4">Full Stack Development</h3>
                    <p className="text-lg text-white/90">मराठीत शिका</p>
                  </div>
                </div>

                
                <div className="p-8">
                  <div className="mb-6">
                    <h3 className="text-2xl font-bold text-black-900 mb-4">
                      Learn Full Stack Development with AI in Marathi
                    </h3>
                    <p className="text-lg text-black-700 leading-relaxed mb-6">
                      AI च्या मदतीने Full Stack Development शिका मराठी भाषेत. व्यावहारिक प्रोजेक्ट्स बनवा आणि आपल्या करिअरमध्ये पुढे जा.
                    </p>
                  </div>

                  
                  <div className="space-y-4 mb-8">
                    <div className="flex items-center gap-3">
                      <SafeIcon icon={FiBook} className="w-5 h-5 text-black-900" />
                      <span className="text-black-700">Complete hands-on curriculum</span>
                    </div>
                    <div className="flex items-center gap-3">
                      <SafeIcon icon={FiUsers} className="w-5 h-5 text-black-900" />
                      <span className="text-black-700">Learn in your native language</span>
                    </div>
                    <div className="flex items-center gap-3">
                      <SafeIcon icon={FiClock} className="w-5 h-5 text-black-900" />
                      <span className="text-black-700">Self-paced learning</span>
                    </div>
                  </div>

                  
                  <div className="mb-8">
                    <h4 className="text-lg font-semibold text-black-900 mb-4">What You'll Learn:</h4>
                    <div className="grid grid-cols-1 gap-2">
                      {[
                        "Frontend Development (React, HTML, CSS)",
                        "Backend Development (Node.js, APIs)",
                        "Database Management",
                        "AI Integration in Web Development",
                        "Deployment & Production"
                      ].map((topic, index) => (
                        <div key={index} className="flex items-start gap-2">
                          <div className="w-2 h-2 bg-black-900 rounded-full mt-2 flex-shrink-0"></div>
                          <span className="text-black-700">{topic}</span>
                        </div>
                      ))}
                    </div>
                  </div>

                  
                  <Link to="https://lp2.itskaivalya.com">
                    <motion.button
                      whileHover={{ scale: 1.05 }}
                      whileTap={{ scale: 0.95 }}
                      className="w-full px-8 py-4 bg-black-900 text-white rounded-lg font-semibold text-lg hover:bg-black-800 transition-colors shadow-lg flex items-center justify-center gap-2"
                    >
                      <span>View Course Details</span>
                      <SafeIcon icon={FiArrowRight} className="w-5 h-5" />
                    </motion.button>
                  </Link>
                </div>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </section>

      
      <section className="py-16 bg-black-50">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeInUp}
            className="text-center mb-12"
          >
            <h2 className="text-3xl md:text-4xl font-bold text-black-900 mb-6 font-serif">
              Why Learn Full Stack Development?
            </h2>
            <div className="w-24 h-1 bg-black-900 mx-auto mt-6 mb-8"></div>
          </motion.div>

          <div className="grid md:grid-cols-3 gap-8">
            {[
              {
                title: "High Demand Skills",
                description: "Full stack developers are in high demand across all industries"
              },
              {
                title: "Complete Understanding",
                description: "Learn both frontend and backend to build complete applications"
              },
              {
                title: "Career Growth",
                description: "Open doors to better opportunities and higher salaries"
              }
            ].map((benefit, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="bg-white p-6 rounded-lg shadow-sm border border-black-200"
              >
                <h3 className="text-xl font-semibold text-black-900 mb-3">{benefit.title}</h3>
                <p className="text-black-700">{benefit.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      
      <section className="py-16 bg-black-900 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <h2 className="text-3xl font-bold mb-6">
              Ready to Start Your Development Journey?
            </h2>
            <p className="text-xl text-black-200 mb-8 max-w-2xl mx-auto">
              Join thousands of students learning practical development skills in Marathi
            </p>
            <Link to="https://lp2.itskaivalya.com">
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="px-8 py-4 bg-white text-black-900 rounded-lg font-semibold text-lg hover:bg-black-100 transition-colors shadow-lg flex items-center gap-2 mx-auto"
              >
                <span>Start Learning Today</span>
                <SafeIcon icon={FiArrowRight} className="w-5 h-5" />
              </motion.button>
            </Link>
          </motion.div>
        </div>
      </section>
    </div>
  );
  */
};

export default CoursesPage;